import { Pin, PinOff } from '@tamagui/lucide-icons';
import { Logo } from '@unistocks/components/logo/logo';
import { UnistocksCircle } from '@unistocks/components/logo/unistocks-circle';
import { Sidebar } from '@unistocks/components/navigation/sidebar';
import { Tooltip } from '@unistocks/components/tooltip/tooltip';
import { RoutesAccordion } from '@unistocks/features/navigation/routes';
import { useStartPage } from '@unistocks/shared/hooks/use-start-page';
import { t } from '@unistocks/shared/localization/index.ts';
import { Link } from 'expo-router';
import React from 'react';
import { AnimatePresence, Nav, View } from 'tamagui';

export const NavSidebar: React.FC = () => {
  const startPageHref = useStartPage();

  return (
    <Sidebar transition={'200ms'} animateOnly={['width']} display="none" $md={{ display: 'flex' }}>
      {({ expanded, hovered, pinned }, togglePinned) => (
        <View bg={'$background'} h={'100%'} py={'$4'} alignItems="center">
          <Link asChild href={startPageHref}>
            <View h={'$4'}>
              <AnimatePresence mode="wait">
                {expanded ? (
                  <Logo
                    key={'logo'}
                    transition={'200ms'}
                    w={'$14'}
                    enterStyle={{ o: 0 }}
                    exitStyle={{ o: 0 }}
                  />
                ) : (
                  <View
                    key={'logo-icon'}
                    transition={'200ms'}
                    enterStyle={{ o: 0 }}
                    exitStyle={{ o: 0 }}
                  >
                    <UnistocksCircle size={'$4'} />
                  </View>
                )}
              </AnimatePresence>
            </View>
          </Link>

          <Nav mt={'$6'} alignSelf="stretch">
            <RoutesAccordion collapsed={!expanded} />
          </Nav>

          <AnimatePresence>
            {hovered ? (
              <Tooltip
                placement="right"
                label={pinned ? t('::Menu:Sidebar:Unpin') : t('::Menu:Sidebar:Pin')}
              >
                <View
                  key={'pinned'}
                  transition={'200ms'}
                  pos={'absolute'}
                  right={'$4'}
                  top={'$5'}
                  cursor="pointer"
                  enterStyle={{ o: 0, y: -10, x: 5, rotate: '20deg' }}
                  exitStyle={{ o: 0, y: -10, x: 5, rotate: '20deg' }}
                  onPress={() => togglePinned()}
                >
                  {pinned ? (
                    <Pin size={'$1'} color={'$unistocks'} />
                  ) : (
                    <PinOff
                      size={'$1'}
                      color={'$headingFont'}
                      hoverStyle={{ color: '$unistocks', o: 0.7 }}
                    />
                  )}
                </View>
              </Tooltip>
            ) : null}
          </AnimatePresence>
        </View>
      )}
    </Sidebar>
  );
};

NavSidebar.displayName = 'NavSidebar';
